define(function(require) {
    const CC = require('CC');
    const BasicModel = require('models/app/BasicModel');
    const Backbone = require('backbone');
    const _ = require('underscore');
    const TokensModel = BasicModel.extend({
        idAttribute: 'accessKey',

        url: function() {
            return `${CC.apiUrl}/users/tokens?description=${this.get('description')}`;
        },
        params: {
            description: undefined
        },

        validation: {
            description: {
                required: true
            }
        },

        destroy: function(options) {
            const self = this;
            return Backbone.sync(
                'delete',
                self,
                _.extend(
                    {
                        url: `${CC.apiUrl}/users/tokens?access_key=${encodeURIComponent(self.get('accessKey'))}`
                    },
                    options
                )
            );
        }
    });
    return TokensModel;
});
